var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audioContainer"},[_c('audio',{key:_vm.voiceUrl,attrs:{"autoplay":"","loop":""}},[_c('source',{attrs:{"src":_vm.voiceUrl,"type":"audio/mp3"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }